import { useState, useEffect, useContext } from 'react';
import { useParams } from 'react-router-dom';

import { DataProvider } from '../store/ContextProvider';
import Loading from './Loading';
import Profiles from '../components/Candidate Info/ViewProfiles';

export default function ViewCandidate() {
  const { BeURL } = useContext(DataProvider);
  const { id } = useParams();

  const [candidate, setCandidate] = useState(null);
  const [, setConsolidatedSkills] = useState(null)
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);


  useEffect(() => {
    if (candidate?.skills && candidate.skills.length > 0) {
      setConsolidatedSkills(candidate.skills.map(item => item.skill))
    }
  }, [candidate])

  useEffect(() => {
    fetch(`${BeURL}/fetch-candidate/${id}`, {
      credentials: 'include'
    })
      .then(res => res.json())
      .then(json => {
        if (json.success) setCandidate(json.candidate);
        else throw new Error(json.message);
      })
      .catch(err => setError(err.message))
      .finally(() => setLoading(false));
  }, [BeURL, id]);

  if (loading) return <Loading />;
  if (error) return <div className="flex justify-center items-center h-full"><p className="text-red-600">Error: {error}</p></div>;


  return (
    <div className="min-h-screen">

      <Profiles candidate={candidate} />

    </div>
  );
}

